// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["css/style","css/editor"], () => (__webpack_require__("./assets/src/js/index.js")))
__webpack_require__.O(undefined, ["css/style","css/editor"], () => (__webpack_require__("./assets/src/scss/main.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["css/style","css/editor"], () => (__webpack_require__("./assets/src/scss/editor.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
